/* src/app/core/pagination/pagination.component.scss */
/*# sourceMappingURL=pagination.component-P7VUXYY4.css.map */
